import { getActionLabel, getChannelIcon } from "@/shared/utils/helperFunctions";

const AnalyticsStepCard = ({ step }) => {
  return (
    <div className="flex flex-col gap-1 px-3 py-1.5 rounded-2xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 items-center justify-center shadow-sm w-fit whitespace-nowrap">
      <div className="px-1.5 py-0.5 border-b border-gray-200 dark:border-gray-800 w-full text-center">
        <h4 className="text-[11px] font-medium text-gray-800 dark:text-gray-200 font-inter">
          Step {step?.step_order}
        </h4>
      </div>
      <div className="flex items-center gap-1">
        {getChannelIcon({
          channel: step?.channel,
          size: 16,
          isCircular: true,
        })}

        <h4 className="text-[11px] font-bold text-gray-800 dark:text-gray-100 font-inter mx-0">
          {getActionLabel(step?.action)}
        </h4>
      </div>
    </div>
  );
};

export default AnalyticsStepCard;
